import { Project } from '@bulthaup/api/db';
import { getProjectAmounts } from '@bulthaup/api/entities/budget';
import { Alert, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Decimal } from 'decimal.js';

import { trpc } from '../../../../../../services/trpc';
import { formatAmount } from '../../../../../../utils/format';

export function EcotaxAlert({ project }: { project: Project }) {
  const { data: supplies } = trpc.projects.getSupplies.useQuery({
    projectId: project.id,
  });

  const { ecofees } = getProjectAmounts(project);
  const totalEcofeeAmount = Object.values(ecofees).reduce(
    (acc, val) => acc.add(val),
    new Decimal(0),
  );

  const totalEcofeeAmountFromSupplies =
    supplies?.reduce(
      (acc, supply) => acc.add(supply.ecofee ?? 0),
      new Decimal(0),
    ) ?? new Decimal(0);

  const diff = totalEcofeeAmount.sub(totalEcofeeAmountFromSupplies);
  const isDisplayed = diff.abs().greaterThan(0.01);

  return (
    isDisplayed && (
      <Alert
        variant="filled"
        color="red"
        title="Écotaxe"
        icon={<IconAlertTriangle size={16} />}
      >
        <Text>
          Dans la fiche fournisseur l'écotaxe présente une différence de :{' '}
          <strong>{formatAmount(Number(diff))}</strong>
        </Text>
      </Alert>
    )
  );
}
